import { type LimitedPartnerDealActivity } from "@vega-api/generated/types/limitedPartnerDealActivity";
import { type DataGridColDef } from "@vega-core/components/DataGrid/types";
import { EMPTY_CELL_VALUE } from "@vega-core/constants/global";
import { m } from "@vega-core/paraglide/messages";
import { formatMoneyShort, isMoneyValid } from "@vega-core/utils/formatMoney";
import { formatMoic, Rounding } from "@vega-core/utils/formatNumber";

import { compareTextCaseInsensitive } from "../utils/compareTextCaseInsensitive";

// Every tab shows the same four columns. committedAmount and moicGross are
// committed-only in the contract, so they fall back to a dash for prospecting
// and passed deals (and for committed deals with no quarterly data uploaded).
export const useDealActivityColumns = () => {
  const columns: DataGridColDef<LimitedPartnerDealActivity>[] = [
    {
      colId: "dealName",
      headerName: m.coInvestments_insights_col_dealName(),
      field: "dealName",
      comparator: compareTextCaseInsensitive,
      minWidth: 240,
      flex: 2,
    },
    {
      colId: "year",
      headerName: m.coInvestments_insights_col_year(),
      valueGetter: ({ data }) => data?.year,
      valueFormatter: ({ data }) =>
        data?.year != null ? String(data.year) : EMPTY_CELL_VALUE,
      flex: 1,
    },
    {
      colId: "committedAmount",
      headerName: m.coInvestments_insights_col_committedAmount(),
      valueGetter: ({ data }) => data?.committedAmount?.amount,
      valueFormatter: ({ data }) =>
        isMoneyValid(data?.committedAmount)
          ? formatMoneyShort(data.committedAmount)
          : EMPTY_CELL_VALUE,
      flex: 1,
    },
    {
      colId: "moicGross",
      headerName: m.coInvestments_insights_col_grossMoic(),
      valueGetter: ({ data }) => data?.moicGross,
      valueFormatter: ({ data }) =>
        data?.moicGross != null
          ? formatMoic(data.moicGross, Rounding.Always2Fractions)
          : EMPTY_CELL_VALUE,
      flex: 1,
    },
  ];

  return columns;
};
